Alerts = require 'app/scripts/views/lib/alerts'
Auth = require 'app/scripts/db/auth'
ApiPromise = require 'app/scripts/network/api-promise'
ApiError = require 'app/scripts/network/api-error'
BoardObserverOptionComponent = require 'app/scripts/views/board-menu/board-observer-option-component'
MemberMultiSelectAutocompleteComponent = require 'app/scripts/views/member/member-multi-select-autocomplete-component'
BoardMenuInviteTeamComponent = require 'app/scripts/views/board-menu/board-menu-invite-team-component'
Confirm = require 'app/scripts/views/lib/confirm'
l = require 'app/scripts/lib/localize'
localizeServerError = require 'app/scripts/lib/localize-server-error'
Member = require 'app/scripts/models/member'
{ maybeDisplayMemberLimitsError } = require 'app/scripts/views/board-menu/member-limits-error'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
ModelLoader = require 'app/scripts/db/model-loader'
View = require 'app/scripts/views/internal/view'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
DisplayInvitationLinkView = require 'app/scripts/views/invitation-link/display-invitation-link-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Promise = require 'bluebird'
t = require('app/scripts/views/internal/recup-with-helpers')('board_member_add_multiple')
tc = require('app/scripts/views/internal/teacup-with-helpers')('board_member_add_multiple')
{ track, trackUe } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'
$ = require 'jquery'
_ = require 'underscore'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ useNonPublicIfAvailable } = require 'app/common/lib/util/non-public-fields-filter'
{ Analytics } = require '@trello/atlassian-analytics'

module.exports = class BoardMemberAddMultipleView extends View
  mixin DisplayInvitationLinkView, @

  viewTitleKey: ->
    if @model.isTemplate() then 'invite to template' else 'invite to board'

  displayType: 'board-member-add-multiple'
  initialInviteMessage: t.l 'im-working-on-this-project-in-trello-and-wanted-to-share-it-with-you'

  events:
    # invitation links
    'click .js-show-invitation-link': 'showInvitationLink'
    'click .js-invitation-link': 'clickInvitationLink'
    'click .js-deactivate-link': 'deactivateInvitationLink'
    'click .js-copy-invitation-link': 'copyInvitationLink'

  initialize: ->
    @onAutocompleteSubmit = @onAutocompleteSubmit.bind(@)
    @onAutocompleteSearch = @onAutocompleteSearch.bind(@)
    @onObserverChange = @onObserverChange.bind(@)
    @onInviteTeamClick = @onInviteTeamClick.bind(@)
    @onInvitationMessageChange = @onInvitationMessageChange.bind(@)
    @selectInvitationMessage = @selectInvitationMessage.bind(@)
    @invitationMessageValue ?= @initialInviteMessage
    @observerValue = 'normal'
    @selectedMemberOptions = []
    @onSelectMemberOption = @onSelectMemberOption.bind(@)
    @onRemoveMemberOption = @onRemoveMemberOption.bind(@)

    organization = @model.getOrganization()
    @loadingOrg = organization?
    if organization?
      @listenTo organization.memberList, 'add remove reset',
        @frameDebounce @renderAutocomplete

    @listenTo @model.memberList, 'add remove reset',
      @frameDebounce @renderAutocomplete

    # in case the bc org admins decides to change the invite permissions
    # when you are looking at this view.
    if organization?
      @listenTo organization, 'change:prefs', @frameDebounce @render

    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

  remove: ->
    ReactDOM.unmountComponentAtNode(@$('.js-autocomplete-root')[0])
    super

  loadOrgData: ->
    organization = @model.getOrganization()
    if organization? and @model.editable()
      if organization.isPO() && organization.isBusinessClass()
        orgModel = ModelLoader.loadOrganizationMembersMinimalWithAvailableLicenseCount organization.id
      else
        orgModel = ModelLoader.loadOrganizationMembersMinimal organization.id

      orgModel.then =>
        @loadingOrg = false
        @renderAutocomplete()
        return
      .done()
    else
      @loadingOrg = false
    return

  render: ->
    @$el.html(
      tc.renderable ->
        tc.div '.invite-board-member-autocomplete.js-autocomplete-root'
    )
    @renderAutocomplete()

    if @sendGASEvent
      Analytics.sendScreenEvent
        name: 'inviteToBoardInlineDialog'
        containers:
          board:
            id: @model.id
          organization:
            id: @model.getOrganization()?.id
    @

  onAutocompleteSubmit: (allowMultiBoardGuests) ->
    users = []
    membersAddedCount = 0
    newBillableGuestsAddedCount = 0

    _.forEach(@selectedMemberOptions, (option) =>
      member = if option.id then @modelCache.get('Member', option.id)
      if member
        @addMember(member)
        if option.wouldBecomeBillableGuest
          newBillableGuestsAddedCount++
        else
          membersAddedCount++
      else
        value = if option.email then option.email else option.username
        type = if option.email then 'email' else 'username'
        users.push { value, type }
    )

    emailRegex = /^[^@]+@[a-z0-9-]+(\.[a-z0-9-]+)+$/i

    Promise
      .map(users, (user) =>
        @getMemberFromUser(user)
          .catch (err) => { hasError: true }
      )
      .then (results) =>
        isErrors = _.some(results, ({ hasError }) => hasError)
        newBillableGuestsAddedCount = _.filter(
          results,
          ({ wouldBecomeBillableGuest }) => wouldBecomeBillableGuest
        ).length
        isBlockedInvites = !allowMultiBoardGuests && newBillableGuestsAddedCount > 0

        if isBlockedInvites or isErrors
          _.each(results, ({ wouldBecomeBillableGuest, hasError }, i) =>
            @selectedMemberOptions[i].blockInvite = wouldBecomeBillableGuest
            @selectedMemberOptions[i].hasError = hasError
          )

        else
          _.each(results, ({ member }, i) =>
            userValue = users[i].value
            if member?
              if @model.id not in member.get('idBoards')
                @addMember(member)
            else if emailRegex.test(userValue)
              @sendEmailInvite(userValue)
          )
          PopOver.hide()
          track('Invitations', 'Send Invites', 'Number of invites sent', '', results.length)
          track('Invitations', 'Send Invites', 'Changed invite message', '', @invitationMessageValue != @initialInviteMessage)

          boardId = @model.get('id')
          isImageBackground = @model.get('prefs')?.backgroundImage?
          numLists = @model.listList.length
          numCards = 0
          numAttachments = 0
          numChecklists = 0
          membersAddedCount = users.length - newBillableGuestsAddedCount
          membersCount = @model.get('memberships')?.length

          @model.listList.models.forEach((list) ->
            numCards += list.cardList.length
            list.cardList.models.forEach((card) ->
              numAttachments += card.attachmentList.length
              numChecklists += card.checklistList.length
            )
          )

          boardData = {
            boardId,
            orgId: @model.getOrganization()?.id || '',
            # selectedMemberOptions represents all users added, regardless of account status
            membersCountBeforeInvite: membersCount - @selectedMemberOptions.length,
            numLists,
            numCards,
            numAttachments,
            numChecklists,
            isImageBackground,
            membersAddedCount,
            newBillableGuestsAddedCount
          }

          trackUe('Invitations', 'adds', 'members', '', 'to board', 'by using invite to board component', boardData)

          # Analytics migration: This GAS event captures all three SP events in this function
          if @sendGASEvent
            Analytics.sendTrackEvent
              action: 'sent'
              actionSubject: 'invitation'
              actionSubjectId: 'boardInvitation'
              source: 'inviteToBoardInlineDialog'
              containers:
                board:
                  id: @model.id
                organization:
                  id: @model.getOrganization()?.id || ''
              attributes:
                numInvitesSent: results.length
                changedMessage: @invitationMessageValue != @initialInviteMessage
                boardData: boardData

  getMemberFromUser: ({ value, type }) ->
    org = @model.getOrganization()

    memberPromise = ApiPromise
      method: 'get'
      url: "/1/members/#{ value }"
      data: { fields: ['idOrganizations', 'idBoards'] }
    .then (data) =>
      memberModel = new Member(data, modelCache: @modelCache)
      if type == 'email'
        memberModel.set 'email', value
      return memberModel
    .catch ApiError.NotFound, (err) ->
      null

    # If the current user is attempting to invite a single board guest
    # (which would turn them into a multi-board guest and incur extra billing),
    # this promise should resolve to true.
    wouldBecomeBillableGuestPromise =
      if org &&
        !org.isFeatureEnabled('multiBoardGuests') &&
        org.getAvailableLicenseCount() > 0
          false
      else
        ApiPromise
          url: '/1/search/members/'
          type: 'get'
          data:
            idBoard: @model.id
            idOrganization: org?.id
            onlyOrgMembers: org?.onlyOrgMembers()
            onlyManagedMembers: org?.onlyManagedMembers()
            onlyOrgOrManagedMembers: org?.onlyOrgOrManagedMembers()
            query: value
          dataType: 'json'
        .then (data) =>
          data.length == 1 and data[0].wouldBecomeBillableGuest

    Promise
      .all [memberPromise, wouldBecomeBillableGuestPromise]
      .then ([member, wouldBecomeBillableGuest]) => { member, wouldBecomeBillableGuest }

  addMember: (member) ->
    if maybeDisplayMemberLimitsError(@$el, @model, member)
      return
    @model.addMember member, @observerValue, @invitationMessageValue, (err, resp) ->
      if err
        errorMessage = if /organization restricts invites/.test(err.message)
            t.l 'team-restricts-invites'
          else
            localizeServerError(err.message)

        Alerts.showLiteralText(errorMessage, 'error', 'alert', 5000)

  sendEmailInvite: (email) ->
    data =
      email: email
      type: @observerValue
      invitationMessage: @invitationMessageValue

    if maybeDisplayMemberLimitsError(@$el, @model)
      return

    ApiPromise
      url: "/1/board/#{@model.id}/members"
      type: 'put'
      dataType: 'json'
      data: data
    .then (data) =>
      member = new Member(data, modelCache: @modelCache)
      track("Invitations", "Send Email Board Invite to New Member", "Role: #{data.type}")
      if @sendGASEvent
        Analytics.sendTrackEvent
          action: 'sent'
          actionSubject: 'invitation'
          actionSubjectId: 'emailBoardInvitation'
          source: 'inviteToBoardInlineDialog'
          containers:
            board:
              id: @model.id
            organization:
              id: @model.getOrganization()?.id || ''
          attributes:
            role: data.type

  onAutocompleteSearch: (query) ->
    query = query.toLowerCase().trim()
    org = @model.getOrganization()
    filteredOrgMembers = []

    # The api does not return results for ghost members in search,
    # because it does not expect users to know the "username" of a
    # ghost user, only the email (since inviting a ghost only uses email).
    # So here we first query the api, and add in the results for ghosts that
    # match the search after (within their org)
    formatMember = (member) =>
        nonPublicAvailableAttributes = {}
        if member.id
          nonPublicAvailableAttributes = {
            avatarUrl: useNonPublicIfAvailable(member, 'avatarUrl'),
            fullName: useNonPublicIfAvailable(member, 'fullName'),
            initials: useNonPublicIfAvailable(member, 'initials')
          }
        return _.extend member.toJSON(), {
          active: true,
          similarity: 0,
          joined: @model.getMembershipFor(member)?
          idOrganizations: [org.id]
          @nonPublicAvailableAttributes
        }

    if org?
      if query.length > 0
        filteredOrgMembers = org.memberList.chain()
          .filter (member) ->
            _.any Util.getMemNameArray(member), (part) ->
              part.indexOf(query) == 0
          .map formatMember
          .value()
      else
        filteredOrgMembers = org.memberList.map formatMember

    if query.length > 2
      return ApiPromise(
        url: '/1/search/members/'
        type: 'get'
        data:
          idBoard: @model.id
          idOrganization: org?.id
          onlyOrgMembers: org?.onlyOrgMembers()
          onlyManagedMembers: org?.onlyManagedMembers()
          onlyOrgOrManagedMembers: org?.onlyOrgOrManagedMembers()
          query: query
        dataType: 'json'
      ).then((members) =>
        _.uniq(
          _.union(members, filteredOrgMembers),
          false,
          (item) => if item.username then item.username else item.email
        )
      )
    else if org?
      return filteredOrgMembers
    else
      return []

  onInviteTeamClick: (e) ->
    track("Invitations", "Add All Org Members to Board")
    if @sendGASEvent
      Analytics.sendUIEvent
        action: 'clicked'
        actionSubject: 'dropdownItem'
        actionSubjectId: 'inviteTeamToBoardDropdownItem'
        source: 'inviteToBoardInlineDialog'
        containers:
          board:
            id: @model.id
          organization:
            id: @model.getOrganization().id

    memsAvailable = @model.orgMembersAvailable().map (member) =>
      _.extend member.toJSON(), {
        active: true,
        similarity: 0,
        joined: @model.hasActiveMembership(member)
        idOrganizations: [@model.getOrganization().id]
      }

    @selectedMemberOptions = _.uniq(
      _.union(@selectedMemberOptions, memsAvailable),
      false,
      (item) => if item.username then item.username else item.email
    )
    @renderAutocomplete()

  onObserverChange: (newValue) ->
    @observerValue = newValue
    @renderAutocomplete()

  onInvitationMessageChange: (e) ->
    @invitationMessageValue = e.target.value
    @renderAutocomplete()

  selectInvitationMessage: ->
    if @invitationMessageValue == @initialInviteMessage
      $('.js-invitation-message').select()

  onSelectMemberOption: (member) ->
    @selectedMemberOptions = _.uniq(
      _.union(@selectedMemberOptions, _.flatten [member]),
      false,
      (item) => if item.username then item.username else item.email
    )
    @renderAutocomplete()

  onRemoveMemberOption: (idx) ->
    @selectedMemberOptions = @selectedMemberOptions.filter((_, i) => i != idx)
    @renderAutocomplete()

  renderAutocomplete: ->
    renderTarget = @$('.js-autocomplete-root')[0]
    if !renderTarget?
      return

    organization = @model.getOrganization()
    autocompleteProps = {
      @onAutocompleteSearch
      displayDetails: true
      displayUsername: false
      shouldFocusOnSelectMemberOption: true
      onSubmit: @onAutocompleteSubmit
      submitText: t.l 'send-invitation'
      emptySearchText: t.l 'looks-like-that-person-isnt-a-trello-member-yet'
      placeholder: t.l 'email-address-or-name'
      onSelectMemberOption: @onSelectMemberOption
      onRemoveMemberOption: @onRemoveMemberOption
      selectedOptions: @selectedMemberOptions
      loadingOrg: @loadingOrg
      showMultiboardGuestWarning: organization?.isFeatureEnabled('multiBoardGuests')
      isTemplate: @model.isTemplate()
    }

    if organization
      availableToInvite = @model.orgMembersAvailable()
      availableToInvite = _.filter(availableToInvite, (member) =>
        return member.get('username') not in _.pluck(@selectedMemberOptions, 'username')
      )
      if availableToInvite.length > 1
        autocompleteProps.extraSearchOption = React.createElement(
          BoardMenuInviteTeamComponent,
            onClick: @onInviteTeamClick
            availableToInvite: availableToInvite
        )
      autocompleteProps.displayOrg = organization

    children = []
    if @model.getOrganization()?.isPremium()
      children.push React.createElement(
        BoardObserverOptionComponent,
        {
          onChange: @onObserverChange
          value: @observerValue
          key: 'observerOption'
        }
      )

    if featureFlagClient.get('enable-invite-email-message', false)
      children.push React.createElement(
        'textarea',
        {
          onChange: @onInvitationMessageChange,
          onClick: @selectInvitationMessage,
          className: 'invitation-message-input js-invitation-message',
          value: @invitationMessageValue,
          key: 'invitationMessage'
          placeholder: t.l 'sharing-is-caring-let-your-collaborators-know-what-youre-working-on'
          maxLength: 500
        }
      )
    ReactDOM.render(
      React.createElement(
        MemberMultiSelectAutocompleteComponent,
        autocompleteProps,
        children
      ),
      renderTarget
    )
